import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("nc_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("nc_user", JSON.stringify(r.data));
      })
      .catch(() => {
        localStorage.removeItem("nc_token");
        localStorage.removeItem("nc_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("nc_token", data.token);
    localStorage.setItem("nc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password, { consent_health_data, accepted_terms }) => {
    let source = null;
    try {
      const raw = localStorage.getItem("alternavit_source_v1");
      source = raw ? JSON.parse(raw) : null;
    } catch {
      source = null;
    }
    const { data } = await api.post("/auth/register", {
      name,
      email,
      password,
      consent_health_data,
      accepted_terms,
      source,
    });
    localStorage.setItem("nc_token", data.token);
    localStorage.setItem("nc_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("nc_token");
    localStorage.removeItem("nc_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
